import { render, staticRenderFns } from "./hall.vue?vue&type=template&id=edfe2224&scoped=true"
import script from "./hall.vue?vue&type=script&lang=js"
export * from "./hall.vue?vue&type=script&lang=js"
import style0 from "./hall.vue?vue&type=style&index=0&id=edfe2224&prod&scoped=true&lang=scss"
import style1 from "./hall.vue?vue&type=style&index=1&id=edfe2224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe2224",
  null
  
)

export default component.exports